import React from 'react';
import {Route, Switch, Redirect, withRouter } from 'react-router-dom'
import Header from "layout/header"
import Footer from "layout/footer"
import {mkLoadable} from './util'
import GA from 'react-ga'
import MessageBanner from 'components/static/message-banner'

        // <Redirect exact from="/election/" to='/election/races/' />
const Body = (props) => {
  return(
    <div style={{backgroundColor: 'white'}}>
      <MessageBanner />
      <Header location={props.location}/>
      <div id="banner" />
      <Route component={logView}/>
      <Switch>
        <Route exact path='/' component={HomePage}/>
        <Route path='/election/:pageId/:userId?' component={ElectionRoutes}/>
        <Route exact path='/election/' component={GeneralElectionPage}/>
        <Route path='/wtf/' component={AboutPage}/>
        <Redirect from="/about/" to="/wtf/"/>
        <Route path='/about/' component={AboutPage}/>
        <Route path='/how-sf-works/' component={HowSFWorksPage}/>
        <Route path='/halp/contribute/' component={DonatePage}/>
        <Route path='/join/' component={HelpOutPage}/>
        <Route path='/housing-shortage/' component={AffordableHousingPage}/>
        <Route path='/terms/' component={TermsPage}/>
        <Route path='/subscribe/' component={SubscribePage}/>
        <Route path='/privacy/' component={PrivacyPage}/>
        <Route path='/community-values/' component={CommunityPage}/>
        <Route path='/test-votepref/:pageId/:userId?' component={VotePrefPage}/>
        <Route exact path='/user/' component={UserPage} />
        <Route exact path='/user/login/' component={UserLoginPage} />
        <Route exact path='/user/logout/' component={UserLogoutPage} />
        <Route exact path='/user/register/' component={UserRegisterPage} />
        <Route exact path='/user/verify/' component={UserVerificationPage}/>
        <Route exact path='/user/forgot/' component={UserForgotPage} />
        <Route exact path='/user/reset-password/' component={UserResetPasswordPage} />
        <Redirect from='/halp/' to="/join/"/>
        <Redirect from='/jobs/' to='/jobs/developer-designer/'/>
        <Route path='/search-results/' component={SearchResultsPage}/>
        <Route component={Page404}/>
      </Switch>
      <Footer />
    </div>
    )
};
        // <Route component={Page404}/>

const GeneralElectionPage = mkLoadable(import("pages/june-5/Election-June-5"));
const ElectionRoutes = mkLoadable(import("pages/june-5/ElectionRoutes"));
const UserPage = mkLoadable(import("pages/user/UserPage"));
const UserLoginPage = mkLoadable(import("pages/user/UserLoginPage"));
const UserLogoutPage = mkLoadable(import("pages/user/UserLogoutPage"));
const UserRegisterPage = mkLoadable(import("pages/user/UserRegisterPage"));
const UserVerificationPage = mkLoadable(import("pages/user/UserVerificationPage"));
const UserForgotPage = mkLoadable(import("pages/user/UserForgotPage"));
const UserResetPasswordPage = mkLoadable(import("pages/user/UserResetPasswordPage"));
const HomePage = mkLoadable(import("pages/home/page"));
// const MayoralDebatePage = mkLoadable(import("pages/mayor/pipe-wrapper"));
const AboutPage = mkLoadable(import("pages/about/AboutPage"));
const HowSFWorksPage = mkLoadable(import("pages/how-sf-works/HowSFWorksPage"));
const AffordableHousingPage = mkLoadable(import("pages/affordable-housing/AffordableHousingPage"));
const TermsPage = mkLoadable(import("pages/terms/page"));
// const BoardPage = mkLoadable(import("pages/bos/BoardPage"));
const HelpOutPage = mkLoadable(import("pages/halp/page"));
const DonatePage = mkLoadable(import("pages/donate/DonatePage"));
const PrivacyPage = mkLoadable(import("pages/privacy/page"));
const CommunityPage = mkLoadable(import("pages/community/page"));
const SubscribePage = mkLoadable(import("pages/subscribe/SubscribePage"));
const Page404 = mkLoadable(import("pages/404/404"));
const VotePrefPage = mkLoadable(import("pages/votePref/VotePrefPage"));
const SearchResultsPage = mkLoadable(import("pages/search/SearchResultsPage"));

try {
  GA.initialize([
    {
      trackingId: 'UA-105777983-1',
    }, 
  ]);
} catch(e) {
  console.error("GA initialize error:", e.message);
}

const logView = () => {
  if(process.env.NODE_ENV === 'production' && navigator.userAgent !== 'ReactSnap') {
    GA.pageview(window.location.pathname + window.location.search);
  }
  return null;
}

export default withRouter(Body)



// WEBPACK FOOTER //
// ./src/body.js